import React from "react"
import {makeStyles} from "@mui/styles"
import {graphql, useStaticQuery} from "gatsby"

const useStyles = makeStyles((theme) => ({
    footer: {
        height: 150,
        width: '100vw',
        justifyContent: 'center',
        color: theme.palette.grey.second,
        fontFamily: 'Montserrat',
        fontSize: 16,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '8px',
        paddingLeft: 16,
        paddingRight: 16,
        textAlign: 'center',

        [theme.breakpoints.down('mobile')]: {
            height: 60,
        },
    },
    divider: {
        width: '60px',
        height: '1px',
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
    }
}))

const Footer = () => {
    const classes = useStyles()
    const {strapiContactUs} = useStaticQuery(graphql`
      query {
        strapiContactUs {
          Copyright
        }
      }
    `)

    return (
        <div className={classes.footer}>
            <div>{strapiContactUs.Copyright}{strapiContactUs.Copyright}{strapiContactUs.Copyright}</div>
            <div className={classes.divider}/>
            <a
                href="/Privacy Policy.pdf"
                target="_blank"
                rel="noopener noreferrer"
                style={{color: 'inherit', textDecoration: 'underline'}}
            >
                Privacy Policy
            </a>
        </div>
    )
}

export default Footer
